module.exports = __webpack_public_path__ + "media/images/custom_page/bae173/card-icon3-3962e67c64ad51b34406153f212868e8.png";